import React from "react";
import { Provider } from "react-redux";
import Home from "./components/Home";
import { store } from "./store";
import {NextUIProvider} from "@nextui-org/react";

function App() {
  return (
          <Provider store={store}>
              <NextUIProvider>
              <Home />
              </NextUIProvider>
          </Provider>
  );
}

export default App;
